<template>
  <Teleport to="body">
    <div v-if="isVisible" class="modal-overlay" :class="{ dark: isDark }" @click.stop>
      <div class="modal-content" @click.stop>
        <div class="header-container">
          <h2 class="modal-title">Historial de Pagos - {{ cliente?.nombre_cliente }}</h2>
          <button @click="$emit('close')" class="btn-close">&times;</button>
        </div>

        <!-- Información del Cliente -->
        <div class="cliente-info">
          <div class="info-item">
            <strong>Cliente:</strong> {{ cliente?.nombre_cliente }}
          </div>
          <div class="info-item">
            <strong>RTN:</strong> {{ cliente?.rtn_cliente }}
          </div>
          <div class="info-item">
            <strong>Estado Actual:</strong>
            <span :class="['estado-badge', 'estado-' + cliente?.estado?.toLowerCase()]">
              {{ cliente?.estado }}
            </span>
          </div>
        </div>

        <!-- Resumen de Cuenta -->
        <div class="resumen-cuenta">
          <div class="resumen-item">
            <span>Monto Original Total:</span>
            <span>{{ formatCurrency(cliente?.monto_original_total) }}</span>
          </div>
          <div class="resumen-item">
            <span>Total Pagado:</span>
            <span class="pagado">{{ formatCurrency(cliente?.monto_pagado_total) }}</span>
          </div>
          <div class="resumen-item">
            <span>Saldo Pendiente:</span>
            <span class="pendiente">{{ formatCurrency(cliente?.saldo_pendiente_total) }}</span>
          </div>
        </div>

        <!-- Historial de Pagos -->
        <div class="historial-section">
          <h3>Historial de Pagos</h3>
          <div v-if="cargandoHistorial" class="loading">Cargando historial...</div>
          <div v-else-if="historialPagos.length === 0" class="no-historial">
            No hay pagos registrados para este cliente
          </div>
          <div v-else class="historial-list">
            <div 
              v-for="pago in historialPagos" 
              :key="pago.id_pago"
              class="pago-item"
            >
              <div class="pago-header">
                <div class="pago-fecha">
                  <i class="bi bi-calendar3"></i>
                  {{ formatDateTime(pago.fecha_pago) }}
                </div>
                <div class="pago-monto">
                  {{ formatCurrency(pago.monto_pago) }}
                </div>
              </div>
              <div class="pago-details">
                <div class="pago-metodo">
                  <i class="bi bi-credit-card"></i>
                  {{ pago.metodo_pago }}
                  <span v-if="pago.numero_transferencia" class="transfer-number">
                    ({{ pago.numero_transferencia }})
                  </span>
                </div>
                <div v-if="pago.notas" class="pago-notas">
                  <i class="bi bi-chat-text"></i>
                  {{ pago.notas }}
                </div>
                <div class="pago-usuario">
                  <i class="bi bi-person"></i>
                  Procesado por: {{ pago.nombre_usuario }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botón de Cerrar -->
        <div class="button-container">
          <button @click="$emit('close')" class="btn btn-cerrar-historial">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import CuentasPorCobrarService from "../../services/cuentasPorCobrarSolicitudes";
import { useToast } from "vue-toastification";

export default {
  name: "HistorialPagosModal",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    cliente: {
      type: Object,
      required: true,
    },
    id_usuario: {  // ⚠️ AGREGAR ESTA PROP (igual que PagarCuentaModal)
      type: Number,
      required: true,
    },
  },
  emits: ['close'],
  
  // AGREGAR ESTOS LIFECYCLE HOOKS (igual que PagarCuentaModal)
  created() {
  },
  
  mounted() {
    // Dark mode — Teleport saca el modal del .app-wrapper, aplicar .dark directamente
    this.isDark = localStorage.getItem('isDarkMode') === 'true';
    this._onToggleDark = () => {
      this.isDark = localStorage.getItem('isDarkMode') === 'true';
    };
    window.addEventListener('poswave:toggle-dark', this._onToggleDark);

    if (this.isVisible) {
      this.cargarHistorialPagos();
    }
  },

  beforeUnmount() {
    window.removeEventListener('poswave:toggle-dark', this._onToggleDark);
  },
  
  setup() {
    const toast = useToast();
    return { toast };
  },
  
  data() {
    return {
      isDark: false,
      cargandoHistorial: false,
      historialPagos: [],
    };
  },
  
  methods: {
    formatCurrency(value) {
      return `L. ${Number(value).toFixed(2)}`;
    },

    formatDateTime(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("es-HN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    async cargarHistorialPagos() {
      
      if (!this.cliente?.id_cliente) {
        return;
      }
      
      this.cargandoHistorial = true;
      try {
        
        const historial = await CuentasPorCobrarService.obtenerHistorialPagos(
          this.cliente.id_cliente,
          this.id_usuario  // ⚠️ AHORA SÍ PASAMOS AMBOS PARÁMETROS
        );
        
        
        this.historialPagos = historial || [];
        
      } catch (error) {
        console.error('💥 Error al cargar historial:', error);
        console.error('💥 Error completo:', error.message);
        console.error('💥 Stack:', error.stack);
        this.toast.error("Error al cargar el historial de pagos: " + error.message);
        this.historialPagos = [];
      } finally {
        this.cargandoHistorial = false;
      }
    },

    resetModal() {
      this.historialPagos = [];
    },
  },
  
  watch: {
    isVisible(newVal) {

      if (newVal) {
        this.resetModal();
        this.cargarHistorialPagos();
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2vh 0;
  z-index: 1000;
  overflow-y: auto;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 700px;
  max-width: 90vw;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin: auto;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.btn-close:hover {
  background-color: #f0f0f0;
  color: #000;
}

.cliente-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 15px;
}

.info-item {
  font-size: 14px;
}

.estado-badge {
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.estado-pendiente {
  background-color: #fff3cd;
  color: #856404;
}

.estado-pagado {
  background-color: #d1e7dd;
  color: #0f5132;
}

.estado-parcial {
  background-color: #d1ecf1;
  color: #0c5460;
}

.resumen-cuenta {
  background-color: #e8f5e9;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.resumen-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.resumen-item:last-child {
  margin-bottom: 0;
  font-weight: bold;
  font-size: 16px;
  border-top: 1px solid #ddd;
  padding-top: 8px;
}

.pagado {
  color: #28a745;
  font-weight: bold;
}

.pendiente {
  color: #dc3545;
  font-weight: bold;
}

.historial-section h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.no-historial {
  text-align: center;
  padding: 20px;
  color: #999;
  font-style: italic;
}

.historial-list {
  max-height: 400px;
  overflow-y: auto;
}

.pago-item {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.pago-header {
  background-color: #f8f9fa;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.pago-fecha {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 14px;
}

.pago-monto {
  font-weight: bold;
  color: #28a745;
  font-size: 16px;
}

.pago-details {
  padding: 12px;
}

.pago-metodo,
.pago-notas,
.pago-usuario {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #666;
}

.pago-metodo {
  color: #007bff;
  font-weight: 500;
}

.transfer-number {
  color: #666;
  font-weight: normal;
}

.pago-usuario {
  margin-bottom: 0;
}

.btn {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-cerrar-historial {
  background-color: #6c757d;
  color: white;
}

.btn-cerrar-historial:hover {
  background-color: #545b62;
}

.button-container {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  border-top: 1px solid #eee;
  margin-top: 20px;
}

/* ===== DARK MODE ===== */
.dark .modal-content {
  background: #2d2d2d;
  color: #ffffff;
}

.dark .header-container {
  border-color: #404040;
}

.dark .modal-title {
  color: #ffffff;
}

.dark .btn-close {
  color: #ffffff;
}

.dark .btn-close:hover {
  background-color: #404040;
  color: #ffffff;
}

.dark .cliente-info {
  background-color: #1e1e1e;
}

.dark .info-item {
  color: #ffffff;
}

.dark .resumen-cuenta {
  background-color: #1e2e1e;
  border-color: #404040;
}

.dark .resumen-item {
  color: #ffffff;
}

.dark .resumen-item:last-child {
  border-color: #404040;
}

.dark .historial-section h3 {
  color: #ffffff;
}

.dark .loading,
.dark .no-historial {
  color: #aaaaaa;
}

.dark .historial-list {
  border-color: #404040;
}

.dark .pago-item {
  border-color: #404040;
}

.dark .pago-header {
  background-color: #3a3a3a;
  border-color: #404040;
}

.dark .pago-fecha {
  color: #aaaaaa;
}

.dark .pago-details {
  background-color: #2d2d2d;
}

.dark .pago-metodo {
  color: #4a9eff;
}

.dark .pago-notas,
.dark .pago-usuario {
  color: #cccccc;
}

.dark .transfer-number {
  color: #aaaaaa;
}

.dark .button-container {
  border-color: #404040;
}

.dark .btn-cerrar-historial {
  background-color: #4a4a4a;
  color: #ffffff;
}

.dark .btn-cerrar-historial:hover {
  background-color: #5a5a5a;
}

/* Media Queries */
@media screen and (max-width: 768px) {
  .modal-content {
    width: 95vw;
    padding: 15px;
  }

  .cliente-info {
    grid-template-columns: 1fr;
   gap: 10px;
 }

 .resumen-item {
   font-size: 13px;
 }

 .pago-header {
   flex-direction: column;
   gap: 10px;
   text-align: center;
 }

 .pago-details {
   padding: 8px;
 }

 .pago-metodo,
 .pago-notas,
 .pago-usuario {
   font-size: 12px;
 }
}
</style>